import React from 'react'
import IMG from '../../assets/events1.png'
import IMG1 from '../../assets/ecommerce.PNG'
import IMG2 from '../../assets/exchange.PNG'
import IMG3 from '../../assets/facture.PNG'
import IMG4 from '../../assets/transport.PNG'
import IMG5 from '../../assets/drumkit.PNG'
import IMG6 from '../../assets/logo.png'
import IMG7 from '../../assets/event.jpeg'
import {AiFillGithub} from 'react-icons/ai'
import './Portfolio.css'

const Portfolio = () => {
  return (
    <section id='portfolio'>
        <h5>Mes projets recents</h5>
        <h2> Portfolio</h2>
        <div className='container portfolio__container'>
            
            <article className='portfolio__item'>
                <div className='portfolio__item_image' >
                  <img src={IMG1} className= 'portfolio__image'/>
                </div>
                <h3>E-library application </h3>
                <div className='portfolio__item__cta'>
                
                <a href='https://github.com/zakariachajae/Ecommerce-chajae-app' className='btn btn-primary' ><AiFillGithub /> GitHub </a>
                </div>
            </article>
            <article className='portfolio__item'>
                <div className='portfolio__item_image' >
                  <img src={IMG2} className= 'portfolio__image'/>
                </div>
                <h3>Exchange Application </h3>
                <div className='portfolio__item__cta'>
                
                <a href='https://github.com/zakariachajae/exchange-website' className='btn btn-primary' ><AiFillGithub /> GitHub </a>
                </div>
            </article>
            <article className='portfolio__item'>
                <div className='portfolio__item_image' >
                  <img src={IMG7} className= 'portfolio__image'/>
                </div>
                <h3>Events Mobile Application </h3>
                <div className='portfolio__item__cta'>
    
                <a href='' className='btn btn-primary' > <AiFillGithub /> GitHub </a>
                </div>
            </article>
            <article className='portfolio__item'>
                <div className='portfolio__item_image' >
                  <img src={IMG3} className= 'portfolio__image'/>
                </div>
                <h3>Facturimi Application </h3>
                <div className='portfolio__item__cta'>
               
                <a href='https://github.com/zakariachajae/factoservices' className='btn btn-primary' ><AiFillGithub /> GitHub </a>
                </div>
            </article>
            <article className='portfolio__item'>
                <div className='portfolio__item_image' >
                  <img src={IMG6} className= 'portfolio__image'/>
                </div>
                <h3>Navetto Application  </h3>
                <div className='portfolio__item__cta'>
                
                <a href='https://github.com/zakariachajae/Navetto-web-application' className='btn btn-primary' ><AiFillGithub /> GitHub</a>
                </div>
            </article>
            <article className='portfolio__item'>
                <div className='portfolio__item_image' >
                  <img src={IMG4} className= 'portfolio__image'/>
                </div>
                <h3>Bus Application </h3>
                <div className='portfolio__item__cta'>
                
                <a href='https://github.com/zakariachajae/application-transport-commun' className='btn btn-primary' ><AiFillGithub /> GitHub </a>
                </div>
            </article>


            
            
        </div>
    </section>
  )
}

export default Portfolio